import PageLayout from 'pages/CreateRubricExisting/PageLayout';
import PageProvider from 'pages/CreateRubricExisting/PageProvider';

const CreateRubricExistingPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default CreateRubricExistingPage;
